export default __webpack_public_path__ + "assets/d5fb3491c6b476dadcd09e55c3474ba8.jpg";